// seoConfig.js - Centralized SEO configuration

const SITE_CONFIG = {
  siteName: 'Smartgave',
  siteUrl: 'https://smartgave.no',
  defaultTitle: 'Smartgave - Finn den perfekte gaven til enhver anledning',
  defaultDescription: 'Finn personlige gaveanbefalinger basert på mottaker, anledning og budsjett. Bryllupsgaver, bursdagsgaver, julegaver og mer. Gratis gaveguide fra Smartgave.no',
  defaultKeywords: 'smartgave, gaver, bursdagsgaver, julegaver, bryllupsgaver, gaveanbefalinger, personlige gaver, gaveguide',
  defaultImage: '/images/og-default.jpg',
  twitterHandle: '@smartgave'
};

const SEO_PAGES = {
  home: {
    title: 'Smartgave - Finn den perfekte gaven til enhver anledning',
    description: 'Personlige gaveanbefalinger for alle anledninger. Bruk vår smarte gavefinner og få forslag tilpasset mottaker og budsjett.',
    keywords: 'smartgave, personlige gaver, gaveanbefalinger, gaveguide, gavesøk',
    path: '/',
    structuredData: {
      "@context": "https://schema.org",
      "@type": "WebSite",
      "name": "Smartgave",
      "url": "https://smartgave.no",
      "description": "Finn personlige gaveanbefalinger basert på mottaker, anledning og budsjett",
      "potentialAction": {
        "@type": "SearchAction",
        "target": "https://smartgave.no/gavefinner?q={search_term_string}",
        "query-input": "required name=search_term_string"
      }
    }
  },
  
  giftFinder: {
    title: 'Smartgave Gavefinner - Personlig gaveanbefalinger basert på dine ønsker',
    description: 'Bruk vår intelligente gavefinner for å få personlige gaveanbefalinger. Svar på noen enkle spørsmål og få perfekte gaveforslag.',
    keywords: 'smartgave, gavefinner, personlige gaver, gaveanbefalinger, gaveguide, intelligent gavesøk',
    path: '/gavefinner',
    structuredData: {
      "@context": "https://schema.org",
      "@type": "WebApplication",
      "name": "Smartgave Gavefinner Verktøy",
      "description": "Intelligent gavefinner som gir personlige anbefalinger",
      "applicationCategory": "LifestyleApplication",
      "operatingSystem": "Web Browser"
    }
  },

  wedding: {
    title: 'Bryllupsgaver - Komplett guide til den perfekte bryllupsgaven',
    description: 'Alt du trenger å vite om bryllupsgaver. Budsjettguide, timing, personlige forslag og populære gavetyper for det perfekte bryllupet.',
    keywords: 'bryllupsgaver, bryllup, gaver til bryllup, bryllupsbudsjett, romantiske gaver',
    path: '/gaver/bryllup',
    structuredData: {
      "@context": "https://schema.org",
      "@type": "Article",
      "headline": "Bryllupsgaver - Guide til den perfekte gaven",
      "description": "Komplett guide til å velge bryllupsgaver. Tips om budsjett, timing og personlige gaver.",
      "author": {
        "@type": "Organization",
        "name": "Smartgave"
      },
      "publisher": {
        "@type": "Organization",
        "name": "Smartgave"
      },
      "mainEntityOfPage": {
        "@type": "WebPage",
        "@id": "https://smartgave.no/gaver/bryllup"
      }
    }
  },

  birthday: {
    title: 'Bursdagsgaver - Ideer og inspirasjon for alle aldre',
    description: 'Finn den perfekte bursdagsgaven! Gaveideer for barn, voksne og seniorer. Personlige forslag basert på alder, interesser og budsjett.',
    keywords: 'bursdagsgaver, bursdag, gaveideer, gaver til barn, gaver til voksne',
    path: '/gaver/bursdag',
    structuredData: {
      "@context": "https://schema.org",
      "@type": "Article",
      "headline": "Bursdagsgaver - Ideer og inspirasjon for alle aldre",
      "description": "Komplett guide til bursdagsgaver for alle aldre og interesser.",
      "author": {
        "@type": "Organization", 
        "name": "Smartgave"
      }
    }
  },

  christmas: {
    title: 'Julegaver - Magiske gaveideer for en koselig jul',
    description: 'Finn de perfekte julegavene! Koselige gaver, familietradisioner og hjemmelagde ideer. Komplett juleguide med budsjett-tips.',
    keywords: 'julegaver, jul, julehandel, koselige gaver, juletradisjoner, hjemmelagde gaver',
    path: '/gaver/jul',
    structuredData: {
      "@context": "https://schema.org",
      "@type": "Article",
      "headline": "Julegaver - Magiske gaveideer for en koselig jul",
      "description": "Komplett guide til julegaver og juletradisjoner.",
      "author": {
        "@type": "Organization",
        "name": "Smartgave"
      }
    }
  },

  electronics: {
    title: 'Elektronikk-gaver - Tech som imponerer i 2025',
    description: 'Oppdaterte tech-gaver og elektronikk som virkelig imponerer. Fra smartklokker til gaming-utstyr. Finn tech-gaver for alle budsjetter.',
    keywords: 'elektronikk gaver, tech gaver, gadgets, smartklokker, gaming, teknologi',
    path: '/gaver/elektronikk'
  },

  forHim: {
    title: 'Gaver til han - Maskuline gaveideer han virkelig vil ha',
    description: 'Gaveideer til menn i alle aldre. Fra praktiske verktøy til hobbyer og opplevelser. Finn gaven som treffer hans interesser.',
    keywords: 'gaver til han, gaver til menn, maskuline gaver, gaveideer menn',
    path: '/mottakere/han'
  },

  forHer: {
    title: 'Gaver til henne - Gjennomtenkte gaver hun vil elske',
    description: 'Personlige gaveideer til kvinner. Fra skjønnhet og wellness til hobbyer og opplevelser. Finn den perfekte gaven til henne.',
    keywords: 'gaver til henne, gaver til kvinner, feminine gaver, gaveideer kvinner',
    path: '/mottakere/henne'
  },

  forKids: {
    title: 'Gaver til barn - Leker og gaver som inspirerer og gleder',
    description: 'Alderspassende gaver til barn. Utviklende leker, kreative aktiviteter og morsomme overraskelser for alle barnealder.',
    keywords: 'gaver til barn, barngaver, leker, pedagogiske gaver, kreative gaver',
    path: '/mottakere/barn'
  },

  contact: {
    title: 'Kontakt Smartgave - Vi hjelper deg med gaveanbefalinger',
    description: 'Har du spørsmål om gaver eller trenger personlig veiledning? Ta kontakt med Smartgaves eksperter for skreddersydde anbefalinger.',
    keywords: 'kontakt smartgave, gavehjelp, personlig veiledning, gaveanbefalinger',
    path: '/kontakt',
    noIndex: false
  }
};

// Helper functions
export const getSEOConfig = (pageKey) => {
  const pageConfig = SEO_PAGES[pageKey];
  if (!pageConfig) {
    return {
      title: SITE_CONFIG.defaultTitle,
      description: SITE_CONFIG.defaultDescription,
      keywords: SITE_CONFIG.defaultKeywords,
      canonicalUrl: SITE_CONFIG.siteUrl,
      ogImage: SITE_CONFIG.siteUrl + SITE_CONFIG.defaultImage
    };
  }

  return {
    title: pageConfig.title,
    description: pageConfig.description,
    keywords: pageConfig.keywords || SITE_CONFIG.defaultKeywords,
    canonicalUrl: SITE_CONFIG.siteUrl + (pageConfig.path || '/'),
    ogImage: SITE_CONFIG.siteUrl + (pageConfig.ogImage || SITE_CONFIG.defaultImage),
    structuredData: pageConfig.structuredData,
    noIndex: pageConfig.noIndex || false
  };
};

export const generateBreadcrumbs = (path) => {
  const pathSegments = path.split('/').filter(segment => segment);
  const breadcrumbs = [
    { name: 'Hjem', url: '/' }
  ];

  let currentPath = '';
  pathSegments.forEach((segment, index) => {
    currentPath += `/${segment}`;
    
    const breadcrumbNames = {
      'gaver': 'Gaver',
      'mottakere': 'Mottakere', 
      'budsjett': 'Budsjett',
      'bryllup': 'Bryllupsgaver',
      'bursdag': 'Bursdagsgaver',
      'jul': 'Julegaver',
      'elektronikk': 'Elektronikk',
      'han': 'Gaver til han',
      'henne': 'Gaver til henne',
      'barn': 'Gaver til barn',
      'gavefinner': 'Gavefinner',
      'kontakt': 'Kontakt'
    };

    breadcrumbs.push({
      name: breadcrumbNames[segment] || segment,
      url: currentPath
    });
  });

  return breadcrumbs;
};

export const generateStructuredDataBreadcrumbs = (breadcrumbs) => {
  return {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": breadcrumbs.map((crumb, index) => ({
      "@type": "ListItem",
      "position": index + 1,
      "name": crumb.name,
      "item": `${SITE_CONFIG.siteUrl}${crumb.url}`
    }))
  };
};

export { SITE_CONFIG, SEO_PAGES };